import styles from './footballTeam.module.css';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FussballWidget } from '../../../../components/FussballDeWidget/FussballDeWidget';
import PersonCard from '../../../../components/PersonCard/PersonCard';
import NewsCard from '../../../Startseite/NewsCarousel/NewsCard';
import AppointmentVisualization from '../../../../components/AppointmentVisualization/AppointmentVisualization';
import { convertAssignmentToPerson } from '../../../../../code/AssignmentPersons'
import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';

function renderDraftContent(rawContent) {
    if (!rawContent) return null;

    try {
        const contentState = convertFromRaw(JSON.parse(rawContent));
        const html = stateToHTML(contentState);
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    } catch (e) {
        console.error("Error parsing Draft.js content:", e);
        return null;
    }
}

const useIsSmallScreen = (maxWidth) => {
    const [isSmall, setIsSmall] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsSmall(window.innerWidth < maxWidth);
        };

        checkScreen(); // Initial check
        window.addEventListener("resize", checkScreen);
        return () => window.removeEventListener("resize", checkScreen);
    }, [maxWidth]);

    return isSmall;
};

function FootballTeam() {
    const { teamSlug } = useParams();
    const navigate = useNavigate(); // ✅ always at top
    const [team, setTeam] = useState(null);
    const [article, setArticle] = useState(null); // ✅ moved up
    const isSmallScreen700 = useIsSmallScreen(700); // ✅ moved up
    const color = '--color-red';
    const colorText = '--main-color-white';

    useEffect(() => {
        fetch(`/api/team/fussball/${teamSlug}`)
            .then(res => res.json())
            .then(data => {
                // Use your conversion function to transform assignments
                const ansprechpartner = data.assignments.map(a =>
                    convertAssignmentToPerson(a.contact ? { ...a.contact, ...a } : a, color, colorText)
                );

                setTeam({
                    ...data,
                    ansprechpartner,
                });
            })
            .catch(err => console.error(err));
    }, [teamSlug]);

    useEffect(() => {
        if (team && team.news_api) {  // <-- check team first
            fetch(team.news_api)
                .then(res => {
                    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}${res}`);
                    return res.json();
                })
                .then(data => {
                    setArticle(data[0]);
                })
                .catch(err => {
                    console.error("Fetch error:", err);
                });
        }
    }, [team]);
    if (!team) return <p>Lade Teamdaten...</p>;

    return (
        <section className={styles.container}>
            <h1>{team.name}</h1>
            <div className={styles.top}>
                <section className={styles.persons}>
                    <h2>Ansprechpartner</h2>
                    <div>
                        {team.ansprechpartner.map((person) => (
                            <PersonCard person={person} />
                        ))}
                    </div>
                </section>


                {article && (
                    <section className={styles.news}>
                        <h2>Letzte News</h2>
                        <div className={styles.newsInfo}>
                            <NewsCard data={article} />
                            <span onClick={() => navigate("/news")}>Weitere News hier...</span>
                        </div>
                    </section>
                )}
            </div>
            {team.information && (
                <section id='infos'>
                    <h2>Informationen</h2>
                    <div>{renderDraftContent(team.information)}</div>
                </section>
            )}
            {team.team_img && team.name != '1. Herren' && (
                <section id='team'>
                    <h2>Mannschaftsfoto</h2>
                    <img className={styles.teamImg} src={team.team_img} alt={team.teamImgText}></img>
                </section>
            )}
            {team.fupa_team_embed && (
                <section id='team'>
                    <h2>Team</h2>
                    <FussballWidget htmlString={team.fupa_team_embed} />
                </section>
            )}


            <section id="Trainingszeiten" >
                <h2>Trainingszeiten</h2>
                <AppointmentVisualization appointments={team.appointments} isSmallScreen={isSmallScreen700} />
            </section>
            {team.fupa_table_embed && (
                <section id='tabelle'>
                    <h2>Tabelle</h2>
                    <FussballWidget htmlString={team.fupa_table_embed} />
                </section>
            )}
            {team.fussballde_matches_embed && (
                <section id='spielplan'>
                    <h2>Spielplan</h2>
                    <FussballWidget htmlString={team.fussballde_matches_embed} />
                </section>
            )}
        </section>
    );
};

export default FootballTeam;
